import { Component, inject, OnDestroy, Signal } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { CoreState, selectClpConfig } from '../redux/core.reducer';
import { HttpClient } from '@angular/common/http';
import { toSignal } from '@angular/core/rxjs-interop'; // Import toSignal
import { map } from 'rxjs/operators';

@Component({
  selector: 'ama-session-information',
  standalone: false,
  templateUrl: './session-information.component.html'
})
export class SessionInformationComponent implements OnDestroy {
  activeModal = inject(NgbActiveModal);

  public token = '';
  public showIcon = false;
  public label = 'Copy Information';
  public version: Signal<string | undefined>;
  private readonly ngUnsubscribe: Subject<void> = new Subject<void>();
  private readonly http = inject(HttpClient);
  private readonly store = inject(Store<CoreState>);

  constructor() {
    this.getTokenSession();
    this.version = toSignal(
      this.http
        .get('/version.txt', { responseType: 'text' })
        .pipe(map((version: string) => version.trim() || undefined))
    );
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  public clipboardToken(): void {
    navigator.clipboard.writeText(
      JSON.stringify({
        url: document.location.href,
        userAgent: navigator.userAgent,
        version: this.version(),
        jSessionId: this.token
      })
    );
    this.label = 'Copied !';
    this.showIcon = true;
  }

  private getTokenSession(): void {
    this.store.select(selectClpConfig).subscribe((config) => {
      if (config?.JsessionId) {
        this.token = config.JsessionId;
      }
    });
  }
}
